import Layout from "../components/layout";
import {useHistory, useParams} from "react-router";
import React, {useEffect, useRef, useState} from "react";
import {toast} from "react-toastify";
import axios from "../axios/axios";
import {Endpoints} from "../axios/endpoints";
import OrderingCard from "../components/orderingCard";
import {getPaymentMethod} from "../utils/utils";
import cn from "classnames";
import FormInput from "../components/formInput";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const idRegex = /^[0-9]{1,32}$/

function OrderView() {
    let {id} = useParams();
    let history = useHistory();

    const [reload, setReload] = useState(true)

    useEffect(() => {
        if (!idRegex.test(id)) {
            toast.warn("Es gab einen Fehler! Du bist wieder auf der Startseite.")
            history.push("/")
        }
    }, [])

    const [order, setOrder] = useState();

    const orderRef = useRef();
    const orderNewRef = useRef();
    const [validated, setVaildated] = useState(false);
    const [price, setPrice] = useState(0.00)
    const [userOrder, setUserOrder] = useState("")

    const handleCalled = e => {
        e.preventDefault()
        e.stopPropagation()

        axios({
            method: "post",
            url: Endpoints.FINISH_CALL_ORDER(id),
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        }).then(res => {
            toast.info("Jetzt kann nicht mehr mitbestellt werden")
            setReload(!reload)
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 404:
                        toast.warn("Diese Bestellung kennen wir nicht...")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }

    const handleClose = e => {
        e.preventDefault()
        e.stopPropagation()

        axios({
            method: "post",
            url: Endpoints.FINISH_ORDER(id),
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        }).then(res => {
            history.push("/")
            toast.info("Bestellung erfolgreich abgeschlossen!")
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 404:
                        toast.warn("Diese Bestellung kennen wir nicht...")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }

    const handleUpdate = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setVaildated(false);


        if (!orderRef.current.checkValidity()) {
            setVaildated(true);
            return;
        }

        axios({
            method: "patch",
            url: Endpoints.ORDERS_USERS(id),
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                "price": price,
                "order": userOrder
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code && res.data.code === 1012) {
                    toast.info("Die Bestellzeit ist schon rum, aber wir leiten deine Anfrage mit Vorbehalt weiter.")
                }
            }

            setReload(!reload)
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 400:
                        if (err.response.data.code === 1009) {
                            toast.warn("Ich glaube es ist schon zu spät um mit zu bestellen")
                            break;
                        }
                        if (err.response.data.code === 1010) {
                            toast.warn("Die Bestellung wurde schon abgeschlossen.")
                            history.push("/")
                            break;
                        }
                        if (err.response.data.code === 1011) {
                            toast.warn("Bei dieser Bestellung kann nicht mehr mit bestellt werden.")
                            history.push("/")
                            break;
                        }

                        toast.warn("Da ist was schiefgelaufen. Bitte überprüfe deine Eingaben nochmal.")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }

    const handleAddOrder = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setVaildated(false);


        if (!orderNewRef.current.checkValidity()) {
            setVaildated(true);
            return;
        }

        axios({
            method: "post",
            url: Endpoints.ORDERS_USERS(id),
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                "price": price,
                "order": userOrder
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code && res.data.code === 1012) {
                    toast.info("Die Bestellzeit ist schon rum, aber wir leiten deine Anfrage mit Vorbehalt weiter.")
                }
            }

            setReload(!reload)
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 400:
                        if (err.response.data.code === 1009) {
                            toast.warn("Ich glaube es ist schon zu spät um mit zu bestellen")
                            break;
                        }
                        if (err.response.data.code === 1010) {
                            toast.warn("Die Bestellung wurde schon abgeschlossen.")
                            history.push("/")
                            break;
                        }
                        if (err.response.data.code === 1011) {
                            toast.warn("Bei dieser Bestellung kann nicht mehr mit bestellt werden.")
                            history.push("/")
                            break;
                        }

                        toast.warn("Da ist was schiefgelaufen. Bitte überprüfe deine Eingaben nochmal.")
                        break;
                    case 404:
                        toast.warn("Unsere Hamster konnten leider nichts zu deiner Anfrage finden")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }

    useEffect(() => {
        axios({
            method: "get",
            url: Endpoints.ORDERS_BY_ID(id),
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        }).then(res => {
            setOrder(res.data || {})
            if ('@me' in res.data["user_orders"]) {
                setPrice(parseFloat(res.data["user_orders"]["@me"].price))
                setUserOrder(res.data["user_orders"]["@me"].order)
            }
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 404:
                        toast.warn("Diese Bestellung kennen wir nicht...")
                        break;
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }, [reload])

    return (
        <Layout>
            {
                order ? (<>
                    <OrderingCard
                        key={order.id}
                        id={order.id}
                        calling={order["who_is_calling"]}
                        customer={order["customer"]}
                        ownOrder={order["own_order"]}
                        mayConfirm={order["may_confirm"]}
                        paymentMethodes={getPaymentMethod(order["payment_methods"])}
                        restaurant={{
                            id: order["restaurant"].id,
                            name: order["restaurant"].name,
                            icon: order["restaurant"].icon,
                        }}
                        timeOfOrdering={order["ordering_for"] + " Uhr"}
                        timeTillOrering={order["accept_until"] + " Uhr"}
                        disabled={order["finished"]}
                        interaction={false}

                        paypalEmail={order["paypal_email"]}
                    />

                    {
                        order["restaurant"].id !== "-1" ? (
                            <div className="card shadow mb-3">
                                <div className="card-body">
                                    <h2 className="card-title"><FontAwesomeIcon className="text-primary"
                                                                                icon={order["restaurant"].icon}/> {order["restaurant"].name}
                                    </h2>
                                    <div className="row">
                                        <div className="col-md">
                                            <div>{order["restaurant"].address.street} {order["restaurant"].address.number}</div>
                                            <div>{order["restaurant"].address.postcode} {order["restaurant"].address.city}</div>
                                        </div>
                                        <div className="col-md">
                                            <h3><FontAwesomeIcon className="text-primary"
                                                                 icon={["fas", "phone-alt"]}/> {order["restaurant"].telephone}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null
                    }

                    {
                        '@me' in order["user_orders"] ? (
                            <div className="card shadow mb-3">
                                <div className="card-body">
                                    <h2 className="card-title">Deine Bestellung</h2>
                                    <form ref={orderRef} onSubmit={e => handleUpdate(e)}
                                          className={cn({"was-validated": validated})}>
                                        <textarea value={userOrder} minLength={1} maxLength={255}
                                                  onChange={e => setUserOrder(e.target.value)}
                                                  className="form-control mb-2" placeholder="Was möchtest du bestellen?"
                                                  required/>
                                        <FormInput label="Preis (in €)" placeholder="5.50"
                                                   type="number" min="0.00" max="10000.00" step="0.01" value={price}
                                                   setValue={setPrice} required/>
                                    </form>

                                    {
                                        order["called"] || order["finished"] ? (
                                            <button disabled className="btn btn-danger text-light float-end"
                                                    onClick={e => {
                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                    }}>Bestellung versiegelt
                                            </button>
                                        ) : (
                                            <button type="submit" className="btn btn-primary text-light float-end"
                                                    onClick={e => handleUpdate(e)}>Aktualisieren
                                            </button>
                                        )
                                    }
                                </div>
                            </div>
                        ) : (
                            <div className="card shadow mb-3">
                                <div className="card-body">
                                    <h2 className="card-title">Was möchtest du bestellen?</h2>
                                    <form ref={orderNewRef} onSubmit={e => handleAddOrder(e)}
                                          className={cn({"was-validated": validated})}>
                                        <textarea value={userOrder} maxLength={255}
                                                  onChange={e => setUserOrder(e.target.value)}
                                                  className="form-control mb-2" placeholder="Was möchtest du bestellen?"
                                                  required/>
                                        <FormInput label="Preis (in €)" placeholder="5.50"
                                                   type="number" min="0.00" max="10000.00" step="0.01" value={price}
                                                   setValue={setPrice} required/>
                                    </form>

                                    {
                                        order["called"] || order["finished"] ? (
                                            <button disabled className="btn btn-danger text-light float-end"
                                                    onClick={e => {
                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                    }}>Bestellung versiegelt
                                            </button>
                                        ) : (
                                            <button type="submit" className="btn btn-primary text-light float-end"
                                                    onClick={e => handleAddOrder(e)}>Bestellen
                                            </button>
                                        )
                                    }
                                </div>
                            </div>
                        )
                    }

                    {Object.entries(order["user_orders"]).length > 0 ?
                        (<div className="card shadow">
                            <div className="card-body">
                                <h2 className="card-title">Alle Bestellungen</h2>
                                {
                                    Object.entries(order["user_orders"]).sort(([aK, aV], [bK, bV]) => {
                                        if (aV.order.toLowerCase() < bV.order.toLowerCase()) {
                                            return -1;
                                        }
                                        if (aV.order.toLowerCase() > bV.order.toLowerCase()) {
                                            return 1;
                                        }
                                        return 0
                                    }).map(([k, v], i) => {
                                        if (k === "@me") {
                                            k = "Du";
                                        }

                                        return (
                                            <div
                                                className={cn("row", {"fw-bold": k === "Du"}, {"text-primary": k === "Du"})}
                                                key={i}>
                                                <div
                                                    className="col-3">{(order["may_confirm"] || order["own_order"]) && !v["in_time"] ? (
                                                    <FontAwesomeIcon className="text-danger"
                                                                     icon={["fas", "clock"]}/>) : null} {k}</div>
                                                <div className="col">{v.order}</div>
                                                <div className="col-2">{v.price.toFixed(2) + "€"}</div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className="card-footer">
                                <div className="d-flex justify-content-end align-items-center">
                                    <div className="me-2">
                                        Gesamt: {order["sum"].toFixed(2)}€
                                    </div>
                                    {(order["may_confirm"] || order["own_order"]) ? (
                                        <div className="btn-group">
                                            {order["called"] === false ? (
                                                <button onClick={e => handleCalled(e)} className="btn btn-warning">Ich
                                                    ruf jetzt an!</button>) : null}
                                            <button onClick={e => handleClose(e)} disabled={order["finished"]}
                                                    className="btn btn-danger">Essen ist da!
                                            </button>
                                        </div>
                                    ) : null
                                    }
                                </div>
                            </div>
                        </div>)
                        : null
                    }

                </>) : null
            }


        </Layout>
    )
}

export default OrderView